import { render, staticRenderFns } from "./AssetsEdit.vue?vue&type=template&id=5b6d498e"
import script from "./AssetsEdit.vue?vue&type=script&lang=js"
export * from "./AssetsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports